import { render, staticRenderFns } from "./LiveKitRoom.vue?vue&type=template&id=5f019c32&scoped=true&lang=pug&"
import script from "./LiveKitRoom.vue?vue&type=script&lang=js&"
export * from "./LiveKitRoom.vue?vue&type=script&lang=js&"
import style0 from "./LiveKitRoom.vue?vue&type=style&index=0&id=5f019c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f019c32",
  null
  
)

export default component.exports